var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('p',{staticClass:"text-centerss"},[_vm._v("人脸识别")]),_c('face',{on:{"change":_vm.changeBase64}}),_c('p',{staticClass:"imgbox"},[_vm._v(" "+_vm._s(_vm.imageSrc)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }